import {
  GET_ADMIN_USER_NOTIFICATIONS,
  CREATE_USER_NOTIFICATIONS,
  UPDATE_USER_NOTIFICATIONS,
  DELETE_USER_NOTIFICATIONS,
  EXPORT_ADMIN_USER_NOTIFICATIONS
} from "./actionTypes"
import { call, put, select, takeEvery } from "redux-saga/effects"
import { getAdminUserNotificationsSucess, getAdminUserNotificationsError, createUserNotificationsError, createUserNotificationsSucess, updateUserNotificationsSucess, updateUserNotificationsError, deleteUserNotificationsSucess, deleteUserNotificationsError, exportAdminUserNotificationsSuccess, exportAdminUserNotificationsError, } from "./actions"
import { AppConfiguration } from "config";
import { genericDeleteRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import { buildCampaignAnalysisCacheKey as buildPaginationCacheKey } from "helpers/sf_utils"
import { showExportEnqueuedToast } from "helpers/export_toast_helper"

const inFlightNotificationRequests = new Set()

function* onGetAdminUserNotifications(action) {
  const useCache = Boolean(action.payload?.useCache)
  const queryParams = action.payload?.queryParams || {}
  const requestedPage = parseInt(queryParams.page_number, 10) || 1
  const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
  const requestKey = `${cacheKey}:${requestedPage}`

  if (useCache) {
    const cachedPage = yield select(
      (state) => state.NotificationsTerminal.page_cache?.[cacheKey]?.[requestedPage]
    )
    if (cachedPage) return
    if (inFlightNotificationRequests.has(requestKey)) return
    inFlightNotificationRequests.add(requestKey)
  }

  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_notifications`,
      queryParams,
      {
        "Authorization": user.token,
        "Content-type": "application/json; charset=UTF-8",
      }
    )
    yield put(getAdminUserNotificationsSucess(response, { queryParams, useCache }))
  } catch (error) {
    yield put(getAdminUserNotificationsError(error))
  } finally {
    if (useCache) {
      inFlightNotificationRequests.delete(requestKey)
    }
  }
}

function* onCreateNotificationsTerminal(action) {
  try {
    let user = bsh_getAdminUserDetails();

    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_notifications`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          "Authorization": user.token,
          "Content-type": "application/json; charset=UTF-8"
        }
      }
    )
    yield put(createUserNotificationsSucess(response))
  } catch (error) {
    yield put(createUserNotificationsError(error))
  }
}

function* onEditNotificationsTerminal(action) {
  try {
    let user = bsh_getAdminUserDetails();

    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_notifications/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          "Authorization": user.token,
          "Content-type": "application/json; charset=UTF-8"
        }
      }
    )
    yield put(updateUserNotificationsSucess(response))
  } catch (error) {
    yield put(updateUserNotificationsError(error))
  }
}

function* onDeleteUserNotifications(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_notifications/${action.payload.id}`,
      {
        headers: {
          "Authorization": user.token,
          "Content-type": "application/json; charset=UTF-8"
        }
      }
    )
    yield put(deleteUserNotificationsSucess(response))
  } catch (error) {
    yield put(deleteUserNotificationsError(error))
  }
}


function* onExportAdminUserNotifications(action) {
  try {
    let user = bsh_getAdminUserDetails();
    yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_notifications/export`,
      {
        body: JSON.stringify({ ...(action.payload?.queryParams || {}) }),
        headers: {
          "Authorization": user.token,
          "Content-type": "application/json; charset=UTF-8"
        }
      }
    )
    yield put(exportAdminUserNotificationsSuccess())
    showExportEnqueuedToast({ reportExportsAvailable: true })
  } catch (error) {
    yield put(exportAdminUserNotificationsError(error))
    ToastAlert.fire({
      icon: ToastAlertIconType.ERROR,
      title: 'Failed to queue notifications export.',
    })
  }
}

function* NotificationsTerminalSaga() {
  yield takeEvery(GET_ADMIN_USER_NOTIFICATIONS, onGetAdminUserNotifications);
  yield takeEvery(CREATE_USER_NOTIFICATIONS, onCreateNotificationsTerminal);
  yield takeEvery(UPDATE_USER_NOTIFICATIONS, onEditNotificationsTerminal);
  yield takeEvery(DELETE_USER_NOTIFICATIONS, onDeleteUserNotifications);
  yield takeEvery(EXPORT_ADMIN_USER_NOTIFICATIONS, onExportAdminUserNotifications);
}

export default NotificationsTerminalSaga
